"use client";
import React, { useState } from "react";
import { IoMdShare } from "react-icons/io";
import { AiOutlineCloseCircle } from "react-icons/ai";
import fb from "../slices/Blogs/assets/fb.png";
import linkedin from "../slices/Blogs/assets/linked.png";
import telegram from "../slices/Blogs/assets/telegram.png";
import attach from "../slices/Blogs/assets/Link.png";
import { format } from "date-fns";
import Image from "next/image";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "next-share";

const SharedLinksWithDate = ({ date, url, recentBlock }) => {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  // Get the base URL and current path
  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const fullUrl = `${baseUrl}${url}`;

  const copylink = (event) => {
    event.preventDefault();
    navigator.clipboard.writeText(fullUrl);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const handleShareClick = (event) => {
    event.preventDefault();
    setShow(true);
  };

  const handleCloseClick = (event) => {
    event.preventDefault();
    setShow(false);
  };

  return (
    <div
      className={`flex items-center justify-between border-t-[1px] border-[#C5C5C5] ${recentBlock ? "pl-[10px]" : ""} `}
      onClick={(event) => event.preventDefault()} // Prevents the entire component click from triggering navigation
    >
      <div>
        <p
          className={`text-[12px] leading-[19px] 
            ${recentBlock ? "text-[#FFFFFF] xl:group-hover:text-[#646464]" : "text-[#646464] font-semibold"} 
          ${show && recentBlock ? "xl:hidden 2xl:block" : "block"}`}
        >
          {format(new Date(date), " MMM do yyyy")}
        </p>
      </div>
      <div>
        {!show && (
          <div
            className={`p-[10px] h-[44px] w-[44px] cursor-pointer transition-all duration-300 ${recentBlock ? "xl:group-hover:bg-[#EFEFEF]" : "bg-[#EFEFEF]"}`}
            onClick={handleShareClick} // Trigger the share button without propagating
          >
            <IoMdShare
              size="24"
              className={`${recentBlock ? "text-[#FFFFFF] xl:group-hover:text-[#646464]" : "text-[#646464]"}`}
            />
          </div>
        )}
        <div
          className={`share gap-[7px] py-[7px] items-center justify-center ${show ? "flex" : "hidden"}`}
        >
          <div className="flex gap-[7px]">
            <FacebookShareButton url={fullUrl}>
              <Image src={fb} alt="" className="h-[30px] w-[30px]" />
            </FacebookShareButton>

            <LinkedinShareButton url={fullUrl}>
              <Image src={linkedin} alt="" className="h-[30px] w-[30px]" />
            </LinkedinShareButton>
            <TwitterShareButton
              url={fullUrl}
              title={
                "next-share is a social share buttons for your next React apps."
              }
            >
              <TwitterIcon size={30} round />
            </TwitterShareButton>

            <TelegramShareButton
              url={fullUrl}
              title={
                "next-share is a social share buttons for your next React apps."
              }
            >
              <Image src={telegram} alt="" className="h-[30px] w-[30px]" />
            </TelegramShareButton>

            <div className="relative cursor-pointer" onClick={copylink}>
              <Image src={attach} alt="" className="h-[30px] w-[30px]" />
              {copied && (
                <span className="text-[12px] absolute mt-[2px]">Copied</span>
              )}
            </div>
          </div>
          <div className="relative cursor-pointer" onClick={handleCloseClick}>
            <AiOutlineCloseCircle size="20" color={"#C4C4C8"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharedLinksWithDate;
